webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

module.exports = {
	"basics": {
		"name": "Pablo Gonzalez Murillo",
		"label": "Senior Software Engineer",
		"picture": "./../assets/photo.jpg",
		"email": "pablohgm@gmail.com",
		"skype": "pablohgm",
		"phone": "+(506) 8312-8226",
		"website": "http://pablogonzalezmurillo.com/",
		"birthDate": "02-15-1989",
		"summary": "I am a technology and software passionate. I have experience working as a backend and frontend developer, contributing with Costa Rica and North American companies. I define myself as an enterprising person and social activist, I have experience leading people and making business decisions. I really love be updated about the changes in the software community to challenge myself to improve as a professional.",
		"location": {
			"address": "",
			"postalCode": "",
			"city": "Alajuela",
			"countryCode": "CR",
			"region": "",
			"country": "Costa Rica"
		},
		"profiles": [
			{
				"network": "Linkedin",
				"username": "pablohgm",
				"url": "https://www.linkedin.com/in/pablohgm"
			},
			{
				"network": "Github",
				"username": "pablohgm",
				"url": "https://github.com/pablohgm"
			}
		]
	},
	"nfpProjects": [
		{
			"name": "ASOFAC",
			"description": "Palliative Care membership system",
			"url": "Private Network",
			"technologies": [
				"AngularJS",
				"Angular Material",
				"LoopBack",
				"JSReport"
			]
		},
		{
			"name": "SanraRed Web Page",
			"description": "Web Page for Social Activist Group",
			"url": "http://sanrared.org/sanrared/",
			"technologies": [
				"HTML",
				"CSS"
			]
		}
	],
	"projects": [
		{
			"name": "SIGEM",
			"description": "Telecommunications System",
			"client": {
				"name": "I.C.E (The biggest Costa Rican telecommunications company)",
				"country": "Costa Rica"
			},
			"technologies": [
				"Java EE",
				"ICEFaces",
				"Maven",
				"Spring"
			],
			"rol": "Java Developer",
			"teamSize": "4+",
			"startDate": "2011",
			"endDate": "2013",
			"highlights": [
				"Migrate old modules to ICEfaces.",
				"Create new modules and release the project for the first stable version.",
				"Manage the technical decision of the project.",
				"During this time I gained proficiency in Front-End technologies such as CSS, HTML, and several javascript based frameworks."
			]
		},
		{
			"name": "Private Project",
			"description": "Legal Cases Management System",
			"client": {
				"name": "Momentum Design Lab",
				"country": "USA"
			},
			"technologies": [
				"Javascript",
				"HTML",
				"CSS",
				"jQuery",
				"EmberJS"
			],
			"rol": "Frontend Developer",
			"teamSize": "8+",
			"startDate": "2013",
			"endDate": "2013",
			"highlights": [
				"Research and learning of new technology: EmberJS"
			]
		},
		{
			"name": "Koddas",
			"description": "Code Review System",
			"client": {
				"name": "Alivebox",
				"country": "Costa Rica"
			},
			"technologies": [
				"Angularjs",
				"Django",
				"REST",
				"Gruntjs"
			],
			"rol": "Full-Stack Developer",
			"teamSize": "2+",
			"startDate": "2014",
			"endDate": "2014",
			"highlights": [
				"Defining the Angularjs UI and Backend architecture",
				"Research and learning of new technology: Django"
			]
		},
		{
			"name": "Helios",
			"description": "Responsive sites for  Renault–Nissan Alliance (Nissan, Renault, Infiniti and Datsun)",
			"client": {
				"name": "Digitas LBI",
				"country": "U.K."
			},
			"technologies": [
				"Javascript",
				"Handlebars",
				"CSS",
				"HTML",
				"SASS"
			],
			"rol": "Senior Frontend Developer",
			"teamSize": "105+",
			"startDate": "2014",
			"endDate": "2014",
			"highlights": [
				"Creating mobile first pages using the same template for all the brands."
			]
		},
		{
			"name": "Onstar",
			"description": "AEM site for ONSTAR",
			"client": {
				"name": "Digitas LBI",
				"country": "USA"
			},
			"technologies": [
				" AngularJS",
				"AEM",
				"CSS"
			],
			"rol": "Senior Frontend Developer",
			"teamSize": "12+",
			"startDate": "2015",
			"endDate": "2016",
			"highlights": [
				"Improving code standards.",
				"Defining grunt task.",
				"Helping with deploy automatization."
			]
		},
		{
			"name": "Viajes",
			"description": "Manage travels System",
			"client": {
				"name": "I.C.E (The biggest Costa Rican telecommunications company)",
				"country": "Costa Rica"
			},
			"technologies": [
				" MVC Spring",
				"JSP",
				"Maven"
			],
			"rol": "Senior Java Developer",
			"teamSize": "2+",
			"startDate": "2016",
			"endDate": "2016",
			"highlights": [
				"Get stable and release a critical project."
			]
		}
	],
	"works": [
		{
			"company": "Alivebox",
			"position": "Full Stack developer",
			"website": "http://alivebox.com",
			"startDate": "2011",
			"endDate": "2014",
			"summary": "",
			"highlights": [
				"I worked on a huge project migration to J2EE, I had responsibilities such as requirement gathering, management, and coding .",
				"I served on several projects center on Front-End technologies. I was in charge of estimations, Linux server administration tasks and coding.",
				"During this time I gained proficiency in Front-End technologies such as CSS, HTML, and several javascript based frameworks."
			]
		},
		{
			"company": "Prodigious",
			"position": "Senior Front-End Developer",
			"website": "http://prodigious .com",
			"startDate": "2014",
			"endDate": "2016",
			"summary": "",
			"highlights": [
				"During my staying in Prodigious, I served as Front-End developer for Onstar account.",
				" I contributed mostly on tasks related to javascript,  API's integration and improving the code quality. ",
				"I assumed experience working with AEM 5.6, Angularjs and HTML5. ",
				"I had the opportunity to take the leadership role and help my team members."
			]
		},
		{
			"company": "Alivebox",
			"position": "Full Stack developer",
			"website": "http://alivebox.com",
			"startDate": "2016",
			"endDate": "2016",
			"summary": "",
			"highlights": [
				"SWorked as a full-stack developer for significant government's project.",
				"Worked under pressure for a critical project.",
				"Requirement analysis and client management were my functions as well."
			]
		}
	],
	"volunteer": [
		{
			"organization": "Sanrared",
			"position": "Founder",
			"website": "http://sanrared.org/",
			"startDate": "2012",
			"endDate": "",
			"summary": "",
			"highlights": []
		}
	],
	"education": [
		{
			"institution": "University of London International Programmes (Coursera)",
			"area": "Creative Programming for Digital Media & Mobile Apps",
			"studyType": "Course",
			"startDate": "2013",
			"endDate": "",
			"gpa": "",
			"courses": []
		},
		{
			"institution": "Universidad Nacional de Costa Rica",
			"area": "Systems Engineering",
			"studyType": "Bachelor",
			"startDate": "2011",
			"endDate": "",
			"gpa": "",
			"courses": []
		},
		{
			"institution": "Universidad Nacional de Costa Rica",
			"area": "Capacity Building Project ICT in SMEs and local governments through the use of Free Software",
			"studyType": "course",
			"startDate": "2010",
			"endDate": "",
			"gpa": "",
			"courses": []
		},
		{
			"institution": "Universidad Nacional de Costa Rica. Office of the Vice-President for Academic Affairs – Direction for Teaching",
			"area": "Office of the Vice-President for Student Affairs, Academic Success Program. Certified performance as a tutor student in the Academic Success program, Two academic years",
			"studyType": "Internship",
			"startDate": "2009",
			"endDate": "2010",
			"gpa": "",
			"courses": []
		},
		{
			"institution": "Ministerio de Educación Pública",
			"area": "Technology Education Component. Introduction to Design Workshop: The color and qualities. Publicity media production",
			"studyType": "course",
			"startDate": "2006",
			"endDate": "",
			"gpa": "",
			"courses": []
		}
	],
	"skills": [
		{
			"name": "Frond-End",
			"level": "90",
			"keywords": [
				"Javascript, HTML, CSS",
				"AngularJS",
				"Vuejs",
				"Javascript Build Tools (Gulp, Webpack, Grunt)",
				"CSS Frameworks (SASS, Bootstrap, Angular Material)"
			]
		},
		{
			"name": "Back-End",
			"level": "60",
			"keywords": [
				"Java",
				"Nodejs"
			]
		},
		{
			"name": "DevOps",
			"level": "30",
			"keywords": [
				"Git",
				"Automation Tools (Jenkins)",
				"AWS",
				"Web Servers (Apache, nginX)",
				"Platforms: Linux, Mac OS X"
			]
		},
		{
			"name": "Agile",
			"level": "80",
			"keywords": [
				"Scrum"
			]
		},
		{
			"name": "Social",
			"level": "80",
			"keywords": [
				"Technical and social leadership",
				"Personal Training"
			]
		},
		{
			"name": "Databases",
			"level": "60",
			"keywords": [
				"Mysql",
				"Postgresql",
				"Oracle"
			]
		}
	],
	"languages": [
		{
			"name": "English",
			"level": "Professional proficiency"
		},
		{
			"name": "Spanish",
			"level": "Native"
		}
	],
	"interests": [
		"Social Activist",
		"HomeBrew",
		"Craft Beer Business",
		"Software Libre",
		"Camping",
		"Traveling"
	],
	"references": [
		{
			"name": "",
			"reference": ""
		}
	]
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(17),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(2);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Outline = __webpack_require__(14);

var _Outline2 = _interopRequireDefault(_Outline);

var _Wordy = __webpack_require__(16);

var _Wordy2 = _interopRequireDefault(_Wordy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    Outline: _Outline2.default,
    Wordy: _Wordy2.default
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _data2 = __webpack_require__(1);

var _data3 = _interopRequireDefault(_data2);

var _ProgressBar = __webpack_require__(15);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'outline',
  data: function data() {
    return _data3.default;
  },

  components: {
    ProgressBar: _ProgressBar2.default
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'progress-bar',
  props: ['percentage'],
  data: function data() {
    return {
      value: this.percentage
    };
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _data2 = __webpack_require__(1);

var _data3 = _interopRequireDefault(_data2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'wordy',
  data: function data() {
    return _data3.default;
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(18),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d0592c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(19),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4611efa8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(20),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46b70a35",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('outline'), _vm._v(" "), _c('wordy')], 1)
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outline"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('img', {
    staticClass: "picture",
    attrs: {
      "src": __webpack_require__(13)
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.basics.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.label))])]), _vm._v(" "), _c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-section"
  }, [_c('h2', [_vm._v("Skype")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.skype))]), _vm._v(" "), _c('h2', [_vm._v("E-mail")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.email))]), _vm._v(" "), _c('h2', [_vm._v("Phone")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.phone))])])]), _vm._v(" "), _c('section', [_vm._m(1), _vm._v(" "), _vm._l((_vm.basics.profiles), function(profile) {
    return _c('div', {
      staticClass: "body-section"
    }, [_c('h2', [_vm._v(_vm._s(profile.network))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(profile.url))])])
  })], 2), _vm._v(" "), _c('section', [_vm._m(2), _vm._v(" "), _vm._l((_vm.skills), function(skill) {
    return _c('div', {
      staticClass: "body-section"
    }, [_c('h2', [_vm._v(_vm._s(skill.name))]), _vm._v(" "), _c('progress-bar', {
      attrs: {
        "percentage": skill.level
      }
    }), _vm._v(" "), _vm._l((skill.keywords), function(tech) {
      return _c('p', {
        staticClass: "skill"
      }, [_vm._v("\n        " + _vm._s(tech) + "\n      ")])
    })], 2)
  })], 2), _vm._v(" "), _c('section', [_vm._m(3), _vm._v(" "), _vm._l((_vm.languages), function(language) {
    return _c('div', {
      staticClass: "body-section"
    }, [_c('p', [_vm._v(_vm._s(language.name) + " - " + _vm._s(language.level))])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Personal Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Social media")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Skills")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Languajes")])])
}]}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "bar",
    style: ({
      width: _vm.value + '%'
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wordy"
  }, [_c('p', [_vm._v(_vm._s(_vm.basics.summary))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.works), function(work) {
    return _c('section', [_c('h2', [_vm._v(_vm._s(work.position))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(work.startDate) + " - " + _vm._s(work.endDate))]), _vm._v(" "), _c('p', [_vm._v("Company: " + _vm._s(work.company))]), _vm._v(" "), _c('ul', _vm._l((work.highlights), function(highlight) {
      return _c('li', [_vm._v(_vm._s(highlight))])
    }))])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.education), function(degree) {
    return _c('section', [_c('span', [_vm._v(_vm._s(degree.startDate) + " " + _vm._s(degree.endDate) + " - ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(degree.area))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(degree.institution))])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('section', [_c('h2', [_vm._v(" Role: " + _vm._s(project.rol))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(project.startDate) + " - " + _vm._s(project.endDate))]), _vm._v(" "), _c('p', [_vm._v("Project name: " + _vm._s(project.name))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(project.description))]), _vm._v(" "), _c('p', [_vm._v("Client: " + _vm._s(project.client.country) + " - " + _vm._s(project.client.name))]), _vm._v(" "), _c('span', [_vm._v("Technologies:")]), _vm._v(" "), _vm._l((project.technologies), function(tech, index) {
      return (project.technologies.length - 1 == index) ? _c('span', [_vm._v("\n      " + _vm._s(tech) + ".\n    ")]) : _c('span', [_vm._v(_vm._s(tech) + ", ")])
    }), _vm._v(" "), _c('p', [_vm._v("Team Size: " + _vm._s(project.teamSize))]), _vm._v(" "), _c('ul', _vm._l((project.highlights), function(highlight) {
      return _c('li', [_vm._v(_vm._s(highlight))])
    }))], 2)
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._l((_vm.nfpProjects), function(project) {
    return _c('section', [_c('h2', [_vm._v("Project name: " + _vm._s(project.name))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(project.description))]), _vm._v(" "), _c('p', [_vm._v("Url: " + _vm._s(project.url))]), _vm._v(" "), _c('span', [_vm._v("Technologies:")]), _vm._v(" "), _vm._l((project.technologies), function(tech, index) {
      return (project.technologies.length - 1 == index) ? _c('span', [_vm._v("\n      " + _vm._s(tech) + ".\n    ")]) : _c('span', [_vm._v(_vm._s(tech) + ", ")])
    })], 2)
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', [_c('ul', _vm._l((_vm.interests), function(interest) {
    return _c('li', [_vm._v(_vm._s(interest))])
  }))])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Experience")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Education")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Professional Projects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Not For Profit Projects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Personal Interests")])])
}]}

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.aa973f04dd8c77a05deb.js